<template>
  <div>
    <v-tabs :activeid="example[selectedLanguageIndex].language">
      <v-tab
        v-for="(language, index) in example"
        :id="language.language"
        :key="`${index}-${language}`"
        :label="language.title"
        :icon="language.coloredIcon"
        :data-index="index"
        @click="onTabSwitch(index)"
      />
      <VTabPanel v-for="(language, index) in example" :key="index">
        <language-example :lang-example="language" />
      </VTabPanel>
    </v-tabs>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { VTabs, VTab, VTabPanel } from '@vonage/vivid-vue';
import { ExampleData } from '@bifrost-dev-docs-mfe/common/types/examples';
import LanguageExample from '@/components/example/LanguageExample.vue';

const route = useRoute();
const router = useRouter();
const selectedLanguageIndex = ref(0);

const props = defineProps({ encodedData: { type: String, required: true } });
const example = computed(() => JSON.parse(decodeURIComponent(props.encodedData)) as ExampleData);

onMounted(() => {
  if (route.query.lang) {
    const index: number = example.value.findIndex(item => item.language === route.query.lang);
    selectedLanguageIndex.value = index !== -1 ? index : 0;
  }
});

const onTabSwitch = async (index: number) => {
  if (selectedLanguageIndex.value !== index) {
    selectedLanguageIndex.value = index;
    if (example.value[index].language !== route.query.lang) {
      const langQuery = example.value[index].language;
      /**
       * *
       * path has been added to avoid conversion of / to %2f during router.push
       * */
      await router.push({ path: route.fullPath, query: { ...route.query, lang: langQuery } });
    }
  }
};
</script>
